import { useQuery } from '@tanstack/react-query'
import type { ModerationItem } from '@/api/pending'
import {
  mergeQueue,
  pendingPollsQuery,
  pendingPostsQuery,
  reportedPollsQuery,
  reportedPostsQuery,
} from './api'

interface Queues {
  queue: ModerationItem[]
  reported: ModerationItem[]
  isLoading: boolean
  isError: boolean
}

/** Pending (posts + polls) and reported (posts + polls), each merged and oldest first. */
export function useModerationQueues(condoId: number, enabled = true): Queues {
  const posts = useQuery({ ...pendingPostsQuery(condoId), enabled })
  const polls = useQuery({ ...pendingPollsQuery(condoId), enabled })
  const reportedPosts = useQuery({ ...reportedPostsQuery(condoId), enabled })
  const reportedPolls = useQuery({ ...reportedPollsQuery(condoId), enabled })
  const all = [posts, polls, reportedPosts, reportedPolls]
  return {
    queue: mergeQueue(posts.data ?? [], polls.data ?? []),
    reported: mergeQueue(reportedPosts.data ?? [], reportedPolls.data ?? []),
    isLoading: all.some((q) => q.isPending && q.fetchStatus !== 'idle'),
    isError: all.some((q) => q.isError),
  }
}
